import { render, staticRenderFns } from "./UiPageTitle.vue?vue&type=template&id=3ca9638d&scoped=true&"
import script from "./UiPageTitle.vue?vue&type=script&lang=js&"
export * from "./UiPageTitle.vue?vue&type=script&lang=js&"
import style0 from "./UiPageTitle.vue?vue&type=style&index=0&id=3ca9638d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca9638d",
  null
  
)

export default component.exports